import { Navigate } from 'react-router-dom';

import PublicLayout from '@/components/Layout/PublicLayout';
import AuthProvider from '@/components/AuthProvider';
import Login from '@/pages/Auth/Login';
import File from '@/pages/File/File';
import { route } from '@/constants/routeName';
import { ErrorForwarder } from '@/components/ErrorBoundary/ErrorForwarder';

const notAuthenticatedRoutes = [
	{
		path: '/',
		element: (
			<AuthProvider>
				<PublicLayout />
			</AuthProvider>
		),
		errorElement: <ErrorForwarder from="no-auth" />,
		children: [
			{
				path: '/login',
				element: <Login />,
			},

			{
				path: '*',
				element: <Navigate to='/login' />,
			},

			{
				path: '',
				element: <Navigate to='/login' />,
			},
			{
				path: `${route.file}/:number/:name/:id`,
				element: <File />,
			},
		],
	},
];
export default notAuthenticatedRoutes;
